var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c("earth", {
        attrs: {
          graphics: _vm.graphics,
          fan: _vm.fan,
          zoomToFirstGraphic: _vm.zoomToFirstGraphic
        },
        on: { clickViewer: _vm.clickViewer }
      }),
      _c("plan", {
        attrs: {
          planId: _vm.planId,
          cityId: _vm.cityId,
          simple: _vm.simple,
          plans: _vm.plans,
          turbine: _vm.turbine,
          tower: _vm.tower,
          windfarm: _vm.windfarm,
          projectItem: _vm.projectItem,
          heightList: _vm.dataSet.datasetHeight
        },
        on: {
          planChange: _vm.planChange,
          updateImg: _vm.updateImg,
          clearImg: _vm.clearImg,
          heightChange: _vm.heightChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }